import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';

import { NavService } from '../../../../../_services/_nav.service';

import { SimuladorPantallaGeneralComponent } from '../../../../../APL/simulador-credito/simulador-pantalla-general.component';

@Component({
  selector: 'app-widget-simulador-credito',
  templateUrl: './widget-simulador-credito.component.html',
  styleUrls: ['./widget-simulador-credito.component.css']
})
export class WidgetSimuladorCreditoComponent implements OnInit {
  loading: boolean = true;
  funcionalidadSIMCRE: any;

  constructor(
    private diaService: DialogService,
    private navServicio: NavService,
  ) { }

  ngOnInit() {
    const funcionalidadesTodas = localStorage.getItem('funcionalidades');
    if (funcionalidadesTodas) {
      const funcionalidadesArray = JSON.parse(funcionalidadesTodas);
      const funSIMCRE = funcionalidadesArray.find((item: any) => item.codigo === 'SIMCRE');
      this.funcionalidadSIMCRE = funSIMCRE ? funSIMCRE : null;
    } else {
      this.funcionalidadSIMCRE = null;
    }
    this.loading = false;
  }

  irSimuladorCredito() {
    const modal = this.diaService.open( SimuladorPantallaGeneralComponent, {
      header: this.navServicio.buscarMensaje( 'SIMULADORCREDITO.LBL_TITULOMODAL' ),
      width: '70%',
      closeOnEscape: true,
      closable: true,
      data: {}
    } );
    modal.onClose.subscribe( ( data: any ) => {} );
  }
}
